exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* Draggable*/\r\n\r\n.drag-border {\r\n    border: #ff525b dashed 2px;\r\n}\r\n\r\n.drag-handle {\r\n    cursor: move; /* fallback if grab cursor is unsupported */\r\n    cursor: grab;\r\n    cursor: -webkit-grab;\r\n}\r\n\r\n.drag-handle:active { \r\n    cursor: grabbing;\r\n    cursor: -webkit-grabbing;\r\n}\r\n\r\n/* Droppable */\r\n\r\n.drag-hint-border {\r\n    border: #3c763d dashed 2px;\r\n}\r\n\r\n.drag-over-border {\r\n    border: #fbbc05 dashed 2px;\r\n}\r\n\r\n.drag-transit {\r\n    border: #3500FF dashed 2px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Synergy/Projects/SFE/Synergy.UI/node_modules/css-loader?{"sourceMap":false,"import":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/ng-drag-drop/style.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../ng-drag-drop/style.css
// module chunks = styles